import { cn } from '@/utils/cn'

interface Step {
  title: string
  description: React.ReactNode
}

interface DocsStepListProps {
  steps: Step[]
  className?: string
}

export function DocsStepList({ steps, className }: DocsStepListProps) {
  return (
    <ol className={cn('my-8 space-y-6', className)}>
      {steps.map((step, index) => (
        <li key={index} className="flex gap-4">
          {/* Step number */}
          <div className="flex-shrink-0">
            <div className="w-8 h-8 rounded-full bg-amber-500/20 border border-amber-500/40 flex items-center justify-center">
              <span className="text-sm font-bold text-amber-600 dark:text-amber-400">
                {index + 1}
              </span>
            </div>
          </div>

          {/* Step content */}
          <div className="flex-1 pt-1">
            <h4 className="text-foreground font-semibold mb-2">{step.title}</h4>
            <div className="text-muted-foreground text-sm leading-relaxed">{step.description}</div>
          </div>
        </li>
      ))}
    </ol>
  )
}
